import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ElementRef,
  SimpleChanges
} from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { uniqueSlugValidator } from '@teem/app/core/utils/email-unique.validator';
import { StoreInformationService } from '@teem/app/core/services/store-information.service';
import { STORE_TYPE } from '@teem/app/core/constants/defaults';
import { ExtraValidators } from '@teem/app/core/utils/ExtraValidators';
import * as moment from 'moment';
import { SharedDataService } from '@teem/app/core/services/shared-data.service';
import { LoaderService } from '@teem/app/core/services/loader.service';
import Swal from 'sweetalert2';
import { environment } from '@teem/environments/environment';
import Survicate from '@survicate/survicate-web-package';
import { messages as i18n } from '@teem/constants/messages';
import { CITY, SAUDI_ARABIA } from '@teem/app/core/constants/country';
import { fileNameFromUrl } from '@teem/helpers/functions';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeliveryComponent } from '../../store-information/components/product-information/components/delivery/delivery.component';
import { GoogleLocationModalComponent } from '@teem/store-module/modals/google-location-modal/google-location-modal.component';
import { country as CountryApi } from '@teem/core/constants/api';
import { category as CategoryApi } from '@teem/constants/api';

@Component({
  selector: 'app-branch-template',
  templateUrl: './branch-template.component.html',
  styleUrls: ['./branch-template.component.scss']
})
export class BranchTemplateComponent {
  @Input() branches: any[] = [];
  @Input() isTemplate: boolean = false;
  @Output() hideTemplate = new EventEmitter<void>();
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('logoFile') myPond: any;
  @Output() onBusinessTypeChange: EventEmitter<any> = new EventEmitter();
  @Input() myStoreType;


  skipTemplate(): void {
    this.hideTemplate.emit();
  }

  countryListApi: string = CountryApi.endPoint;
  regionListApi: string = CountryApi.regions;
  cityListApi: string = CountryApi.cities;
  productCategoriesApi: string = CategoryApi.productCategoriesList;
  storeFrontCategoriesApi: string = CategoryApi.storeFrontCategoriesApi;
  businessTypes = ['Product', 'Service'];
  categoryInput: string = '';
  categories: string[] = [];
  selectedBusinessType = 'Product';
  editBusinessType = false;
  locationQuery: string = '';
  whatsappNumber: string = '';
  internationalDeliveryCost: number | null = null;
  ksaDeliveryCost: number | null = null;
  enableCareemRadius: boolean = false;
  cityDeliveryOption = 'manual';
  cityDeliveryCost: number = 1;
  shopComment: string = '';
  wordCount: number = 0;
  coverPhoto: string | null = null;
  storeInformationForm: FormGroup;
  deliveryForm: FormGroup;
  basicInfo: any;
  storeUrl: any;
  isLogistiq: boolean = false;
  outsideSA: boolean = true;
  selectedWeekDays: Array<any> = [];
  coverImageUrl: any = '';
  isSubmitted: boolean = false;
  // shopStatus: any;
  autoAccept: any;
  storeInfo: any;
  selectedCountry: any;
  selectedDistrict: any;
  selectedRegion: any;
  selectedCity: any;
  coverImageFile: any = null;
  isAllowDeliveryDiscounts: boolean = true;
  showOtoFrom: boolean = false;
  otoAccountType: string = 'new_account';
  cities: any = '';
  districts: any = '';
  selectedStorefrontCategories: Array<any> = [];
  selectedProductCategories: Array<any> = [];
  templateData: any;
  weekDays: any = [
    { value: 'sunday', label: 'Sunday' },
    { value: 'monday', label: 'Monday' },
    { value: 'tuesday', label: 'Tuesday' },
    { value: 'wednesday', label: 'Wednesday' },
    { value: 'thursday', label: 'Thursday' },
    { value: 'friday', label: 'Friday' },
    { value: 'saturday', label: 'Saturday' }
  ];

  schedule = [
    {
      day: 'Monday', active: true,slot: [
        { start: '--:--', end: '--:--' }
      ],expanded: false,show: true
    },
    {
      day: 'Tuesday',active: true, slot: [
        { start: '--:--', end: '--:--' }
      ],expanded: false,show: false
    },
    {
      day: 'Wednesday', active: true, slot: [
        { start: '--:--', end: '--:--' }
      ], expanded: false, show: false
    },
    {
      day: 'Thursday', active: true, slot: [
        { start: '--:--', end: '--:--' }
      ], expanded: false, show: false
    },
    {
      day: 'Friday', active: true, slot: [
        { start: '--:--', end: '--:--' }
      ], expanded: false, show: false
    },
    {
      day: 'Saturday', active: true, slot: [
        { start: '--:--', end: '--:--' }
      ], expanded: false, show: false
    },
    {
      day: 'Sunday', active: true, slot: [
        { start: '--:--', end: '--:--' }
      ], expanded: false, show: false
    },
  ];

  timeModel: any = {
    sunday: false,
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
  }

  // ngOnChanges(changes: SimpleChanges) {
  //     if (this.templateData) {
  //       this.fetchTemplateInfo();
  //     }
  // }

  // uploadToServer = {
  //   process: (fieldName, file, metadata, load, error, progress, abort) => {
  //     let oldFileName = this.coverImageUrl ? fileNameFromUrl(this.coverImageUrl) : null;
  //     let timer;
  //     if (oldFileName != file.name) {
  //       // Create data object containing the file and the file metadata
  //       const formData = new FormData();
  //       formData.append('logo_image', file, file.name);
  //       formData.append('store_type',STORE_TYPE.PRODUCT);
  //       formData.append(fieldName, JSON.stringify(metadata));

  //       this.storeInformationService.uploadFile(formData).subscribe(
  //         (data) => { },
  //         (err) => { },
  //       );
  //       // Progress indicator supported, set progress to 25% of 1
  //       progress(true, 0.25, 1);
  //       // Fake completion after 1 second
  //       timer = setTimeout(() => {
  //         load(file); // or { body: 'unique-file-id' }
  //       }, 1000);
  //     } else {
  //       load(this.coverImageUrl);
  //       progress(false);
  //     }

  //     // Should expose an abort method so the request can be cancelled by the user
  //     return {
  //       abort: () => {
  //         // abort your request here (we clear timer for demo purposes)
  //         clearTimeout(timer);
  //         // updates FilePond interface
  //         abort();
  //       }
  //     };
  //   },

  //   revert: (uniqueFileId, load, error) => {
  //     // remove file from server here

  //     this.storeInformationService.removeFile(STORE_TYPE.PRODUCT).subscribe(
  //       (data) => {
  //         load();
  //       },
  //       (err) => { console.error(`Remove File Upload Error: ${err.message}`); },
  //     );
  //   }
  // };

  // pondOptions = {
  //   multiple: false,
  //   // allowRevert: false,
  //   allowReplace: false,
  //   allowRemove: true,
  //   allowImageResize: true,
  //   allowImagePreview: true,
  //   // labelIdle: `
  //   // <div style="text-align: center">
  //   // 	<p>${i18n.drag_and_drop_file}</p>
  //   // </div>`,
  //   imageResizeMode: 'cover',
  //   imagePreviewHeight: 300,
  //   imagePreviewMinHeight: 300,
  //   imagePreviewMaxHeight: 300,
  //   imageResizeTargetWidth: 700,
  //   imageResizeTargetHeight: 300,
  //   server: this.uploadToServer,
  //   acceptedFileTypes: 'image/png, image/jpeg, image/gif',
  //   labelIdle: `<span class="icon-upload"></span>`,
  //   beforeRemoveFile: this.pondHandleRemoveFile,
  // };

  // async pondHandleRemoveFile(event: any) {
  //   let confirm = await Swal.fire({
  //     title: i18n.are_you_sure,
  //     text: i18n.store.delete_cover_image_confirm,
  //     icon: 'info',
  //     showCloseButton: true,
  //     showCancelButton: true,
  //     focusConfirm: false,
  //     confirmButtonText: i18n.yes,
  //     cancelButtonText: i18n.no_cancel_it
  //   })
  //   if (confirm.isConfirmed) {
  //     return true
  //   }
  //   return false;
  // }

  constructor(
    private formBuilder: FormBuilder,
    private storeInformationService: StoreInformationService,
    private sharedDataService: SharedDataService,
    private loaderService: LoaderService,
    private modalService: NgbModal
  ) {
    this.createStoreFormGroup()
    this.fetchTemplate()
  }

  ngOnInit(): void {
    this.basicInfo = (window as any).userInfo;
    this.sharedDataService.asObservable().subscribe((data) => {
      if (data && data.userInfo) {
        Survicate.init({
          workspaceKey: environment?.survicate_key,
          disableTargeting: true,
          traits: {
            id: data.userInfo.id,
            email: data.userInfo.email
          }
        });
        this.basicInfo = data.userInfo;

        if (this.basicInfo?.is_oto_info) {
          this.showOtoFrom = true;
        }
      }
    })
  }

  triggerFileInput(): void {
    this.fileInput.nativeElement.click();
  }

  openCloseTimeModel(day: string) {
    this.timeModel[day] = !this.timeModel[day];
  }

  openTimeModel(day: string) {
    this.timeModel[day] = !this.timeModel[day];

    this.getWeekDaysFormGroup(day).get('available').setValue(this.timeModel[day]);
    const start_time = this.getWeekDaysFormGroup(day).get('start_time');
    if (this.timeModel[day] == true) {
      start_time.setValidators([Validators.required]);
    } else {
      start_time.clearValidators();
    }
    start_time.updateValueAndValidity();
  }

  pondHandleInit() {
  }

  pondHandleAddFile(event: any) {
  }

  validateInput(event: KeyboardEvent): void {
    const inputChar = String.fromCharCode(event.charCode);

    // Regular expression to allow only English, Arabic characters and numbers
    const regex = /^[\u0621-\u064A\u0660-\u0669A-Za-z0-9 ]+$/;

    if (!regex.test(inputChar)) {
      event.preventDefault(); // Block the input if it's not a valid character
    }
  }

  onChangePhoto(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.coverPhoto = e.target.result;
      };
      reader.readAsDataURL(input.files[0]);
      this.storeInformationForm.patchValue({
        cover_image: input.files[0],
      });
      this.storeInformationForm.get('cover_image')?.updateValueAndValidity();
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  openGoogleMap() {
    const modalRef = this.modalService.open(GoogleLocationModalComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.result.then(result => {
      this.storeInformationForm.get('pin_drop_location').setValue(result.marker);
      this.storeInformationForm.get('address').setValue(result.address);
    })
  }

  createStoreFormGroup() {
    this.storeInformationForm = this.formBuilder.group({
      name: [null, Validators.required],
      slug: [null, [Validators.required], [uniqueSlugValidator(this.storeInformationService, 'product')]],
      phone: [null, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(5), Validators.maxLength(30)]],
      whatsapp_phone: [null, [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(5), Validators.maxLength(30)]],
      shop_type: [STORE_TYPE.PRODUCT],
      description: [null],
      terms_conditions: [null],
      privacy_policy: [null],
      customer_additional_info: [null],
      cover_image: [null],
      additional_info: this.formBuilder.array([
        this.newInfo()
      ]),
      active: [null],
      storefront_categories: [[]],
      product_categories: [[]],
      upload_reference_files: [0],
      allow_additional_info: [0],
      allow_instant_order: [0],
      allow_scheduled_order: [0],
      allow_shop_comment: [1],
      shop_comments: [null, Validators.required],

      building_name: [null, Validators.required],
      street: [null, Validators.required],
      area: [null, Validators.required],
      address: [null, Validators.required],
      region: [null],
      country_id: [null, Validators.required],
      district: [null],
      city: [null],
      city_id: [null],
      region_id: [null],
      district_id: [null],
      pin_drop_location: [null],


      own_delivery: [null],
      same_city: [null],
      same_city_delivery_with: [null],
      outside_city: [null],
      outside_ksa: [null],
      logistiq_email: [null, [Validators.email]],
      logistiq_password: [null],
      delivery_cost_same_city: [null, [Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]],
      delivery_cost_inside_ksa: [null, [Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]],
      delivery_cost_international: [null, [Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]],

      working_days: [[]],
      week_days: this.newWeekDays(),

      allow_pick_up: [null],
      pick_up_cost: [null],
      allow_shipping: [null],
      allow_self_manage_delivery: [null],
      self_manage_delivery: this.selfDelivery(),
      allow_instant_delivery: [null],
      allow_local_delivery: [null],
      allow_same_city_delivery: [null],
      instant_delivery: this.instantDelivery(),
      same_city_delivery: this.sameCityDelivery(),
    }
    );
  }

  convertToSlug(input: string) {
    let slug = input.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
    this.storeInformationForm.get('slug').setValue(slug);
    this.storeUrl = `${environment.baseUrl}/${this.storeInformationForm.get('slug').value}`;
  }

  newInfo(): FormGroup {
    return this.formBuilder.group({
      information: [null],
      make_mandatory: [null],
    })
  }

  fetchTemplateInfo() {
    this.loaderService.startLoading();
    if (!this.templateData.error) {
      let data = this.templateData;
      this.storeInfo = data;
      this.storeInformationForm.patchValue(data);

      if (data.city_id == CITY.JEDDAH) {
        this.isLogistiq = true
      }

      // this.coverImageUrl = this.storeInfo.cover_image;
      this.coverPhoto = data.cover_image_url;

      if (data.days?.length > 0) {
        this.storeInformationForm.get('week_days.same_everyday')
          .setValue(data.same_everyday);

        this.selectedWeekDays = data.days.map(day => day.day);
        let tempDay = '';
        data.days.forEach(app => {
          const day = app.day;
          if (!day) return;

          // Mark day as available
          const dayGroup = this.storeInformationForm.get(`week_days.${day}`);
          if (!dayGroup) return;

          dayGroup.get('available')?.setValue(true);
          this.timeModel[day] = true;

          const slotsArray = dayGroup.get('slots') as FormArray;
          if (tempDay != day) {
            tempDay = day;
            slotsArray.clear(); // Remove default slot(s)
            this.resetScehdule(day);
          }

          // Backend may return one or multiple time ranges
          // const timeRanges = app.time_ranges ?? [{
          //   opening_time: app.opening_time,
          //   closing_time: app.closing_time,
          // }];

          // timeRanges.forEach((range, idx) => {
            const startTime = moment(app.opening_time, 'HH:mm:ss');
            const endTime = moment(app.closing_time, 'HH:mm:ss');

            const slot = this.createSlot();
            slot.patchValue({
              start_time: startTime.format('HH:mm'),
              end_time: endTime.format('HH:mm'),
            });
            this.updateDayTime(day,startTime.format('HH:mm'), endTime.format('HH:mm'));
            slotsArray.push(slot);
          // });
        });
      }

      if (data.country_id == SAUDI_ARABIA) {
        this.outsideSA = false;
      }

      if (data.country_id) {
        this.selectedCountry = {
          id: data.country_id,
          name: data.country_name
        }
        this.storeInformationForm.get('country_id').setValue(data.country_id);
        this.onChangeCountry(this.selectedCountry);
      }

      if (data.region_id) {
        this.selectedRegion = {
          id: data.region_id,
          name: data.region_name
        }
        this.storeInformationForm.get('region_id').setValue(data.region_id);
      }

      if (data.city_name) {
        this.storeInformationForm.get('city').setValue(data.city_name);
      }

      if (data.city_id) {
        this.selectedCity = {
          id: data.city_id,
          name: data.city_name
        }
        this.storeInformationForm.get('city_id').setValue(data.city_id);
      }

      if (data.district_id) {
        this.selectedDistrict = {
          id: data.district_id,
          name: data.district_name
        }
        this.storeInformationForm.get('district_id').setValue(data.district_id);
      }

      if (data.slug) {
        this.storeUrl = `${environment.baseUrl}/${data.slug}`;
      }

      if (data.product_categories) {
        this.selectedProductCategories = data.product_categories.map((item) => item.name);
      }

      if (data.storefront_categories) {
        this.selectedStorefrontCategories = data.storefront_categories;
      }

      if (!data.shop_comments) {
        this.storeInformationForm.get('allow_shop_comment').setValue(0);
        let shop_comments = this.storeInformationForm.get('shop_comments');
        shop_comments.setValue(null);
        shop_comments.setValidators([]);
        shop_comments.updateValueAndValidity();
      } else {
        this.storeInformationForm.get('allow_shop_comment').setValue(1);
      }

      if (data.additional_information.length) {
        const controlArray = this.additionalInfo;
        data.additional_information.forEach((app) => {
          const aif = this.newInfo();
          aif.patchValue(app);
          controlArray.push(aif);
        });
        this.deleteAdditionalInfo(0);
      } else {
        // $("#checkbox-002").slideToggle();
        // $("#additioanl-information").hide();
        // $("#additioanl-information").addClass('d-none');
        // this.storeInformationForm.get('allow_additional_info').setValue(0);
      }
      setTimeout(function () {
        // $('select[nice-select]').niceSelect('update');
      }, 100);

    }
    this.loaderService.stopLoading();
  }

  resetScehdule(inputDay: string){
    const formattedDay = inputDay.charAt(0).toUpperCase() + inputDay.slice(1).toLowerCase();
    const dayEntry = this.schedule.find(d => d.day === formattedDay);
    dayEntry.slot = [];
  }

  updateDayTime(inputDay: string, newStart: string, newEnd: string) {
    const formattedDay = inputDay.charAt(0).toUpperCase() + inputDay.slice(1).toLowerCase();
    const dayEntry = this.schedule.find(d => d.day === formattedDay);

    if (!dayEntry) return;

    // Ensure slots array exists
    if (!Array.isArray(dayEntry.slot)) {
      dayEntry.slot = [];
    }

    dayEntry.slot.push({
      start: newStart,
      end: newEnd
    });
    
  }

  onUnselectProductCategory(data: any) {
    if (this.storeInfo && this.storeInfo.associated_product_categories) {
      if (this.storeInfo.associated_product_categories.indexOf(data.item.name) !== -1) {
        data.event.preventDefault();
        Swal.fire(i18n.error.cant_delete_category, i18n.error.category_associated_with_product, 'error');
      }
    }
  }

  newWeekDays(): FormGroup {
    const formGroup = this.formBuilder.group({
      same_everyday: [false], // Checkbox for applying the same time to all days
      is_24hour: [false],
      monday: this.createDayGroup(),
      tuesday: this.createDayGroup(),
      wednesday: this.createDayGroup(),
      thursday: this.createDayGroup(),
      friday: this.createDayGroup(),
      saturday: this.createDayGroup(),
      sunday: this.createDayGroup(),
    });

    // Listen for changes to 'same_everyday' and update other days accordingly
    formGroup.get('same_everyday')?.valueChanges.subscribe((checked) => {
      if (checked) {
        this.applyMondayToAll(this.storeInformationForm.get('week_days') as FormGroup);
      }
    });

    formGroup.get('is_24hour')?.valueChanges.subscribe((checked) => {
      if (checked) {
        this.apply24ToAll(this.storeInformationForm.get('week_days') as FormGroup);
      }
    });

    return formGroup;
  }

  createDayGroup(): FormGroup {
    const group = this.formBuilder.group({
      available: [false],
      slots: this.formBuilder.array([this.createSlot()], this.validateSlotSequence())
    });

    // When "available" changes, update slot validations
    group.get('available')?.valueChanges.subscribe((available: boolean) => {
      const slots = group.get('slots') as FormArray;

      slots.controls.forEach(slot => {
        const startCtrl = slot.get('start_time');
        const endCtrl = slot.get('end_time');

        if (available) {
          startCtrl?.setValidators([Validators.required]);
          endCtrl?.setValidators([Validators.required]);
        } else {
          startCtrl?.clearValidators();
          endCtrl?.clearValidators();
        }

        startCtrl?.updateValueAndValidity({ emitEvent: false });
        endCtrl?.updateValueAndValidity({ emitEvent: false });
      });

      slots.updateValueAndValidity({ emitEvent: false });
    });

    return group;
  }


  getSlots(day: string): FormArray {
    return this.storeInformationForm.get('week_days')!.get(day)!.get('slots') as FormArray;
  }

  addSlot(day: string) {
    const slots = this.getSlots(day);
    slots.push(this.createSlot());

    // 🔥 force validate new + previous slot relationship
    slots.updateValueAndValidity();
  }

  removeSlot(day: string, index: number) {
    this.getSlots(day).removeAt(index);
  }

  validateSlotTime() {
    return (group: AbstractControl) => {
      const dayGroup = group.parent?.parent as FormGroup;

      // If not available, skip validation completely
      if (dayGroup && !dayGroup.get('available')?.value) {
        return null;
      }

      const start = group.get('start_time')?.value;
      const end = group.get('end_time')?.value;

      if (!start || !end) return null;

      const [sH, sM] = start.split(':').map(x => +x);
      const [eH, eM] = end.split(':').map(x => +x);

      const startMin = sH * 60 + sM;
      const endMin = eH * 60 + eM;

      return endMin <= startMin ? { timeInvalid: true } : null;
    };
  }


  validateSlotSequence(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!(control instanceof FormArray)) return null;

      const slots = control.controls;
      let hasError = false;

      // Clear previous errors on each slot first
      slots.forEach(slot => {
        if (slot.hasError('slotOrderInvalid')) {
          slot.setErrors(null);
        }
      });

      for (let i = 1; i < slots.length; i++) {
        const prevEnd = slots[i - 1].get('end_time')?.value;
        const currStart = slots[i].get('start_time')?.value;

        if (!prevEnd || !currStart) continue;

        const [pH, pM] = prevEnd.split(':').map(x => +x);
        const [cH, cM] = currStart.split(':').map(x => +x);

        const prevEndMin = pH * 60 + pM;
        const currStartMin = cH * 60 + cM;

        if (currStartMin <= prevEndMin) {
          // Mark error on current slot control
          slots[i].setErrors({ ...(slots[i].errors || {}), slotOrderInvalid: true });
          hasError = true;
        }
      }

      return hasError ? { slotOrderInvalid: true } : null;
    };
  }

  createSlot(): FormGroup {
    const slot = this.formBuilder.group(
      {
        start_time: [null],
        end_time: [null],
      },
      {
        validators: [this.validateSlotTime()],
      }
    );

    const updateParent = () => {
      const parentArray = slot.parent as FormArray;
      if (parentArray) {
        parentArray.updateValueAndValidity();
      }
    };

    // slot.get('new_start_time_group')?.valueChanges.subscribe(v => {
    //   if (v.hours != null && v.minutes != null) {
    //     const time = `${v.hours}:${v.minutes}`;
    //     slot.get('start_time')?.setValue(time, { emitEvent: false });
    //     updateParent();
    //   }
    // });

    // slot.get('new_end_time_group')?.valueChanges.subscribe(v => {
    //   if (v.hours != null && v.minutes != null) {
    //     const time = `${v.hours}:${v.minutes}`;
    //     slot.get('end_time')?.setValue(time, { emitEvent: false });
    //     updateParent();
    //   }
    // });

    slot.get('start_time')?.valueChanges.subscribe(() => updateParent());
    slot.get('end_time')?.valueChanges.subscribe(() => updateParent());

    return slot;
  }
  // Function to copy Monday's schedule to all other days
  // applyMondayToAll(formGroup: FormGroup) {
  //   const monday = formGroup.get('monday')?.value;
  //   ['monday','tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].forEach(day => {
  //     formGroup.get(day)?.patchValue(monday);
  //     this.onChangeNewStartTime(day, 'old');
  //     this.onChangeNewEndTime(day);
  //     let start = moment(this.storeInformationForm.get('week_days.'+day+'.start_time').value, 'HH:mm:ss');
  //     let end = moment(this.storeInformationForm.get('week_days.'+day+'.end_time').value, 'HH:mm:ss');
  //     this.updateDayTime(day, start.format('HH:mm'), end.format('HH:mm'));
  //   });
  // }
  // applyMondayToAll(weekDaysGroup: FormGroup) {
  //   const mondayGroup = weekDaysGroup.get('monday') as FormGroup;
  //   const mondaySlots = (mondayGroup.get('slots') as FormArray).controls as FormGroup[];
  //   const mondayAvailable = mondayGroup.get('available')?.value;

  //   const days = ['tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

  //   days.forEach(day => {
  //     this.resetScehdule(day);
  //     const dayGroup = weekDaysGroup.get(day) as FormGroup;
  //     const daySlots = dayGroup.get('slots') as FormArray;

  //     // 1️⃣ Remove existing slots
  //     while (daySlots.length > 0) {
  //       daySlots.removeAt(0);
  //     }

  //     // 2️⃣ Set available to match Monday
  //     dayGroup.get('available')?.setValue(mondayAvailable, { emitEvent: false });

  //     // 3️⃣ Copy Monday slots
  //     mondaySlots.forEach((slotCtrl,idx) => {
  //       const slotValue = slotCtrl.getRawValue(); // { start_time, end_time }

  //       const newSlot = this.createSlot();
  //       newSlot.patchValue({
  //         start_time: slotValue.start_time,
  //         end_time: slotValue.end_time
  //       }, { emitEvent: false });

  //       daySlots.push(newSlot);

  //       this.updateDayTime(day,slotValue.start_time, slotValue.end_time);
  //     });

  //     // 4️⃣ Update validations
  //     daySlots.updateValueAndValidity();
  //     dayGroup.updateValueAndValidity();
  //   });
  // }
  applyMondayToAll(weekDaysGroup: FormGroup) {
    const mondayGroup = weekDaysGroup.get('monday') as FormGroup;
    const mondaySlots = (mondayGroup.get('slots') as FormArray).controls as FormGroup[];
    const mondayAvailable = mondayGroup.get('available')?.value;

    const days = ['tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

    // 🔥 Fix — first reset Monday schedule
    this.resetScehdule('monday');

    // 🔥 And update Monday slots to schedule array
    mondaySlots.forEach(slotCtrl => {
        const val = slotCtrl.getRawValue();
        this.updateDayTime('monday', val.start_time, val.end_time);
    });

    days.forEach(day => {
      this.resetScehdule(day);
      const dayGroup = weekDaysGroup.get(day) as FormGroup;
      const daySlots = dayGroup.get('slots') as FormArray;

      while (daySlots.length > 0) {
        daySlots.removeAt(0);
      }

      dayGroup.get('available')?.setValue(mondayAvailable, { emitEvent: false });

      mondaySlots.forEach(slotCtrl => {
        const slotValue = slotCtrl.getRawValue();

        const newSlot = this.createSlot();
        newSlot.patchValue(slotValue, { emitEvent: false });
        daySlots.push(newSlot);

        this.updateDayTime(day, slotValue.start_time, slotValue.end_time);
      });

      daySlots.updateValueAndValidity();
      dayGroup.updateValueAndValidity();
    });
  }


  apply24ToAll(formGroup: FormGroup) {
    const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

    days.forEach((day,idx) => {
      this.resetScehdule(day);
      const dayGroup = formGroup.get(day) as FormGroup;
      const slots = dayGroup.get('slots') as FormArray;

      // 1️⃣ Remove all existing slots
      while (slots.length > 0) {
        slots.removeAt(0);
      }

      // 2️⃣ Create a new single slot
      const slot = this.createSlot();

      // 3️⃣ Set 24-hour time
      slot.get('start_time')?.setValue('00:00', { emitEvent: false });
      slot.get('end_time')?.setValue('23:59', { emitEvent: false });
      this.updateDayTime(day,'00:00', '23:59');
      // 4️⃣ Mark the day as available
      dayGroup.get('available')?.setValue(true, { emitEvent: false });

      // 5️⃣ Add the slot to the day
      slots.push(slot);

      // 6️⃣ Update validations
      slots.updateValueAndValidity();
      dayGroup.updateValueAndValidity();
    });
  }


  newFormatIn24HoursTime(t: any) {
    return moment(`${t.hours}:${t.minutes}:00}`, 'HH:mm:ss').format('HH:mm:ss')
  }

  get weekDaysInfo() {
    return this.storeInformationForm.get('week_days') as FormGroup;
  }

  getWeekDaysFormGroup(index) {
    return this.weekDaysInfo.controls[index] as FormGroup;
  }

  getNewStartTimeGroup(day) {
    // return this.getWeekDaysFormGroup(day).controls.new_start_time_group;
    return this.getWeekDaysFormGroup(day).controls.start_time;
  }

  getNewEndTimeGroup(day) {
    // return this.getWeekDaysFormGroup(day).controls.new_end_time_group;
    return this.getWeekDaysFormGroup(day).controls.end_time;
  }

  onChangeNewStartTime(day, type = 'new') {
    const startTimeValue = this.getNewStartTimeGroup(day).value;
    // this.storeInformationForm.get('week_days.'+day+'.start_time').setValue(this.newFormatIn24HoursTime(startTimeValue));
    this.storeInformationForm.get('week_days.' + day + '.start_time').setValue(startTimeValue);

    if (type == 'new') {
      // let endTime = moment(this.newFormatIn24HoursTime(startTimeValue), 'HH:mm:ss').add(15, 'minutes');
      // this.storeInformationForm.get('week_days.'+day+'.new_end_time_group').setValue({
      //   hours: endTime.format('HH'),
      //   minutes: endTime.format('mm')
      // });
      // this.onChangeNewEndTime(day);
    }

    // setTimeout(function () {
    //   $('select[nice-select]').niceSelect('update');
    // }, 100);
  }

  onChangeNewEndTime(day) {
    const endTimeValue = this.getNewEndTimeGroup(day).value;
    // this.storeInformationForm.get('week_days.'+day+'.end_time').setValue(this.newFormatIn24HoursTime(endTimeValue));
    this.storeInformationForm.get('week_days.' + day + '.end_time').setValue(endTimeValue);
  }

  selfDelivery(): FormGroup {
    return this.formBuilder.group({
      delivery_cost: [null],
      delivery_radius: [null],
    })
  }

  get selfDeliveryInfo() {
    return this.storeInformationForm.get('self_manage_delivery') as FormGroup;
  }

  getSelfDeliveryFormGroup(index) {
    return this.selfDeliveryInfo.controls[index] as FormGroup;
  }

  deliveryRadius(value) {
    if (value < 0) {
      value = 0;
    } else if (value > 100) {
      value = 100;
    } else if (!value) {
      value = 0;
    }

    this.selfDeliveryInfo.get('delivery_radius')?.setValue(value);
  }

  instantDelivery(): FormGroup {
    return this.formBuilder.group({
      careem: this.careemInstantDelivery(),
      mrsool: this.mrsoolInstantDelivery()
    })
  }

  sameCityDelivery(): FormGroup {
    return this.formBuilder.group({
      mrsool: this.mrsoolInstantDelivery()
    })
  }

  careemInstantDelivery(): FormGroup {
    return this.formBuilder.group({
      enabled: [0],
      careem_discount: [null],
      careem_min_amount: [null],
      careem_min_discount: [null],
      careem_expiry_date: [null],
      careem_expiry_time: [null],
      days: [null], // this.newWeekDays(),
    });
  }

  get additionalInfo() {
    return this.storeInformationForm.get('additional_info') as FormArray;
  }

  addAdditionalInfo() {
    this.additionalInfo.push(this.newInfo());
  }

  deleteAdditionalInfo(index) {
    this.additionalInfo.removeAt(index);
  }

  getInformationFormGroup(index) {
    return this.additionalInfo.controls[index] as FormGroup;
  }

  makeMandatory(index, event) {
    const information = this.additionalInfo.controls[index].get('information');
    if (event.target.checked) {
      information.setValidators([Validators.required]);
    } else {
      information.clearValidators();
    }
    information.updateValueAndValidity();
  }

  allowShopComments(event) {
    let shop_comments = this.storeInformationForm.get('shop_comments');
    if (event.target.checked) {
      shop_comments.setValidators([Validators.required]);
    } else {
      shop_comments.setValue(null);
      shop_comments.setValidators([]);
    }
    shop_comments.updateValueAndValidity();
  }

  mrsoolInstantDelivery(): FormGroup {
    return this.formBuilder.group({
      enabled: [0],
      mrsool_discount: [null],
      mrsool_min_amount: [null],
      mrsool_min_discount: [null],
      mrsool_expiry_date: [null],
      mrsool_expiry_time: [null],
      days: [null], // this.newWeekDays(),
    });
  }

  get instantDeliveryInfo() {
    return this.storeInformationForm.get('instant_delivery') as FormGroup;
  }

  getInstantDeliveryInfoFormGroup(index) {
    return this.instantDeliveryInfo.controls[index] as FormGroup;
  }

  changeInstantDelivery(value, option: string) {
    if (option == 'careem') {
      value = (value == 'careem') ? 1 : 0;
      this.getInstantDeliveryInfoFormGroup('careem').get('enabled').setValue(value);
      value = !value;
      this.getInstantDeliveryInfoFormGroup('mrsool').get('enabled').setValue(value);
    }

    if (option == 'mrsool') {
      value = (value == 'mrsool') ? 1 : 0;
      this.getInstantDeliveryInfoFormGroup('mrsool').get('enabled').setValue(value);
      value = !value;
      this.getInstantDeliveryInfoFormGroup('careem').get('enabled').setValue(value);
    }
  }

  get sameCityDeliveryInfo() {
    return this.storeInformationForm.get('same_city_delivery') as FormGroup;
  }

  getSameCityDeliveryInfoFormGroup(index) {
    return this.sameCityDeliveryInfo.controls[index] as FormGroup;
  }

  changeSameCityDelivery(value, option: string) {
    if (option == 'mrsool') {
      value = (value == 'mrsool') ? 1 : 0;
      this.getSameCityDeliveryInfoFormGroup('mrsool').get('enabled').setValue(value);
    }
  }

  get f() {
    return this.storeInformationForm.controls;
  }

  fetchTemplate() {
    this.loaderService.startLoading();
    this.storeInformationService.getTemplateInfo().subscribe((data: any) => {
      if (data.error && this.branches.length == 0) {
        this.isTemplate = true;
      }
      this.loaderService.stopLoading();
      this.templateData = data;
      this.fetchTemplateInfo();
    });
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer && event.dataTransfer.files.length > 0) {
      const file = event.dataTransfer.files[0];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.coverPhoto = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  get filteredSchedule() {
    return this.schedule.filter(s => s.show);
  }

  get activeSchedule() {
    return this.schedule.filter(s => s.active);
  }

  onActiveChange(day: any): void {
    day.show = day.active;
  }

  toggleDropdown(index: number): void {
    this.schedule[index].expanded = !this.schedule[index].expanded;
  }

  everyday = {
    selected: false,
    uuid: 'unique-everyday-id'
  };

  refs = {
    selected: false,
    uuid: 'unique-refs-id'
  };

  additional = {
    selected: false,
    uuid: 'unique-additional-id'
  };

  deliveryCity = {
    selected: false,
    uuid: 'unique-deliveryCity-id'
  };

  deliveryKSA = {
    selected: false,
    uuid: 'unique-deliveryKSA-id'
  };

  deliveryInt = {
    selected: false,
    uuid: 'unique-deliveryInt-id'
  };

  is24HoursOpen = {
    selected: false,
    uuid: 'unique-24HoursOpen-id'
  };

  comments = {
    selected: false,
    uuid: 'unique-comments-id'
  };

  checkboxes = {
    'unique-deliveryCity-id': this.deliveryCity,
    'unique-additional-id': this.additional,
    'unique-refs-id': this.refs,
    'unique-deliveryKSA-id': this.deliveryKSA,
    'unique-deliveryInt-id': this.deliveryInt,
    'unique-24HoursOpen-id': this.is24HoursOpen,
    'unique-everyday-id': this.everyday,
    'unique-comments-id': this.comments,
  };

  onCheckboxChange(event: Event, uuid: string): void {
    const isChecked = (event.target as HTMLInputElement).checked;
    const checkbox = this.checkboxes[uuid];
    if (checkbox) {
      checkbox.selected = isChecked;
    }
  }

  get startTimeGroup() {
    return this.storeInformationForm.controls.start_time_group;
  }

  get endTimeGroup() {
    return this.storeInformationForm.controls.end_time_group;
  }

  get whatsappValue(): string {
    return `https://wa.me/${this.whatsappNumber}`;
  }

  get locationValue(): string {
    return `https://maps.google.com/?q=${this.locationQuery}`;
  }


  addCategory(): void {
    const input = this.categoryInput.trim();
    if (input && !this.categories.includes(input)) {
      this.categories.push(input);
      this.selectedStorefrontCategories.push(input);
      this.categoryInput = '';
    }
  }

  removeCategory(index: number) {
    this.categories.splice(index, 1);
  }

  onCommentInput(event: Event): void {
    const input = (event.target as HTMLTextAreaElement).value;
    const words = input.split(/\s+/).filter(w => w.length > 0);

    if (words.length <= 78) {
      this.shopComment = input;
      this.wordCount = words.length;
    } else {
      this.shopComment = words.slice(0, 78).join(' ');
      this.wordCount = 78;
    }
  }

  getAllErrors(form: FormGroup | FormArray): { [key: string]: any; } | null {
    let hasError = false;
    const result = Object.keys(form.controls).reduce((acc, key) => {
      const control = form.get(key);
      const errors = (control instanceof FormGroup || control instanceof FormArray) ? this.getAllErrors(control) : control.errors;
      if (errors) {
        acc[key] = errors;
        hasError = true;
      }
      return acc;
    }, {} as { [key: string]: any; });
    return hasError ? result : null;
  }

  onSubmit() {
    this.isSubmitted = true;
    if (this.storeInformationForm.valid) {

      let fd = this.storeInformationForm.value;

      // if (this.coverImageFile) {
      //   fd.cover_image = this.coverImageFile;
      // }
      if (this.storeInformationForm.get('cover_image')?.value) {
        fd.cover_image = this.storeInformationForm.get('cover_image')?.value;
      }

      if (!this.coverImageUrl) {
        fd.delete_cover_image = true;
      }

      fd.upload_reference_files = fd.upload_reference_files ? 1 : 0;
      fd.allow_instant_order = fd.allow_instant_order ? 1 : 0;
      fd.allow_scheduled_order = fd.allow_scheduled_order ? 1 : 0;

      this.loaderService.startLoading();

      this.storeInformationService.updateBranchTemplateInfo(fd, { headers: { 'Content-Type': 'multipart/form-data' } }).subscribe(
        (res) => {
          this.loaderService.stopLoading();
          // let userInfo = this.sharedDataService.getItem('userInfo');
          // userInfo.has_store = true;
          // this.sharedDataService.setItem('userInfo', userInfo);
          // this.basicInfo = userInfo;
          // Survicate.showSurvey(environment?.survey?.storefront, { forceDisplay: true });
          Swal.fire(i18n.done, i18n.branch_template.updated, 'success'); //'Store information updated'
          this.skipTemplate()
        },
        (err) => {
          this.loaderService.stopLoading();
          if (err.status === 422) {
            if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
              let validationErrors = err.error.errors;
              Object.keys(validationErrors).forEach((prop) => {
                this.storeInformationForm.get(prop)?.setErrors({
                  serverError: validationErrors[prop]
                })
              })
            }
          }

          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        }
      )
      this.isSubmitted = false;
    } else {
      console.error('Form is invalid. Invalid controls:');
      Object.keys(this.storeInformationForm.controls).forEach(key => {
        const control = this.storeInformationForm.get(key);
        if (control?.invalid) {
          console.error(`${key} errors:`, control.errors);
        }
      });
    }
  }

  activateOption(event, option: string) {
    if (option == 'pick-up') {
      let pick_up_cost = this.storeInformationForm.get('pick_up_cost');
      if (event.target.checked) {
        pick_up_cost.setValidators([Validators.required, Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]);
      } else {
        pick_up_cost.setValue(null);
        pick_up_cost.setValidators([Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]);
      }
      pick_up_cost.updateValueAndValidity();
    }

    if (option == 'self-managed') {
      let delivery_cost = this.selfDeliveryInfo.get('delivery_cost');
      let delivery_radius = this.selfDeliveryInfo.get('delivery_radius');

      if (event.target.checked) {
        delivery_cost.setValidators([Validators.required, Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]);
        delivery_radius.setValidators([Validators.required, Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]);
      } else {
        delivery_cost.setValue(null);
        delivery_radius.setValue(null);
        delivery_cost.setValidators([Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]);
        delivery_radius.setValidators([Validators.pattern("^([0-9][0-9]*(\.[0-9]*[0-9])?|0\.[0-9]*[0-9])$")]);
      }

      delivery_cost.updateValueAndValidity();
      delivery_radius.updateValueAndValidity();
    }
  }

  openOtoAccount(type: string) {
    this.showOtoFrom = true;
    this.otoAccountType = type;
  }

  openDeliveryDiscountModel(formGp: string, deliveryType: string) {
    const modalRef = this.modalService.open(DeliveryComponent, { windowClass: 'delivery-modal-popup' });

    let deliveryValues;

    if (formGp == 'instant_delivery') {
      deliveryValues = this.storeInformationForm.get('instant_delivery').get(deliveryType);
    }

    if (formGp == 'same_city_delivery') {
      deliveryValues = this.storeInformationForm.get('same_city_delivery').get(deliveryType);
    }

    // this.deliveryForm.patchValue(values);
    if (deliveryType == 'mrsool') {
      let expirydate = moment(deliveryValues.value?.mrsool_expiry_date);
      // let expirydate = moment(deliveryValues.value?.mrsool_expiry_date, 'YYYY-MM-DD');
      // let expiryTime = moment(deliveryValues.value?.mrsool_expiry_date, 'HH:mm:ss');
      this.deliveryForm = this.formBuilder.group({
        // days: [deliveryValues.value.days],
        days: this.newWeekDays(),
        delivery_discount: [deliveryValues.value.mrsool_discount, [Validators.min(0.01), Validators.required]],
        discount_expiry: [expirydate.format('YYYY-MM-DD'), Validators.required],
        discount_expiry_time: [expirydate.format('HH:mm:ss')],
        discount_expiry_time_group: this.formBuilder.group({
          hours: [expirydate?.format('HH')],
          minutes: [expirydate?.format('mm')],
          // am: [false]
        }),
        minimum_order_size: [deliveryValues.value.mrsool_min_amount, [Validators.min(0.01), Validators.required]],
        minimum_discount_size: [deliveryValues.value.mrsool_min_discount, [Validators.min(0.01), Validators.required]]
      });
    }

    if (deliveryType == 'careem') {
      let expirydate = moment(deliveryValues.value?.careem_expiry_date);
      // let expirydate = moment(deliveryValues.value?.careem_expiry_date, 'YYYY-MM-DD');
      // let expiryTime = moment(deliveryValues.value?.careem_expiry_date, 'HH:mm:ss');
      this.deliveryForm = this.formBuilder.group({
        // days: [deliveryValues.value.days],
        days: this.newWeekDays(),
        delivery_discount: [deliveryValues.value.careem_discount, [Validators.min(0.01), Validators.required]],
        discount_expiry: [expirydate.format('YYYY-MM-DD'), Validators.required],
        discount_expiry_time: [expirydate.format('HH:mm:ss')],
        discount_expiry_time_group: this.formBuilder.group({
          hours: [expirydate?.format('HH')],
          minutes: [expirydate?.format('mm')],
          // am: [false]
        }),
        minimum_order_size: [deliveryValues.value.careem_min_amount, [Validators.min(0.01), Validators.required]],
        minimum_discount_size: [deliveryValues.value.careem_min_discount, [Validators.min(0.01), Validators.required]]
      });
    }

    let days
    if (deliveryValues.value.days && (deliveryValues.value.days?.length > 0)) {
      this.selectedWeekDays = deliveryValues.value.days.map((day) => day.day);
      days = deliveryValues.value.days;
    } else {
      days = Object.entries(deliveryValues.value.days)
        .filter(([day, details]) => (details as any).available) // Filter only available days
        .map(([day, details]) => ({
          day,
          opening_time: (details as any).start_time,
          closing_time: (details as any).end_time,
        }));
    }

    // new UI
    days.forEach((app) => {
      if (app.day) {
        let day = app.day;
        let startTime = moment(app.opening_time, 'HH:mm:ss');
        let endTime = moment(app.closing_time, 'HH:mm:ss');

        this.deliveryForm.get('days.' + day + '.available').setValue(true);
        this.deliveryForm.get('days.' + day + '.start_time').setValue(startTime.format('HH:mm:ss'));
        this.deliveryForm.get('days.' + day + '.end_time').setValue(endTime.format('HH:mm:ss'));

        // this.deliveryForm.get('days.'+day+'.new_start_time_group').setValue({
        //   hours: startTime.format('HH'),
        //   minutes: startTime.format('mm')
        // });

        // this.deliveryForm.get('days.'+day+'.new_end_time_group').setValue({
        //   hours: endTime.format('HH'),
        //   minutes: endTime.format('mm')
        // });

        this.timeModel[day] = true;
      }
    });

    // Set id on modal dialog
    // modalRef.componentInstance.el.nativeElement.parentNode.parentNode.classList.add("data-table__wrap");
    // modalRef.componentInstance.el.nativeElement.parentNode.id = "my-store_info";
    modalRef.componentInstance.formType = null;//this.formType;
    modalRef.componentInstance.storeInformationForm = this.storeInformationForm;
    modalRef.componentInstance.form = this.deliveryForm;
    modalRef.componentInstance.formId = deliveryType;//this.formId;
    // modalRef.componentInstance.onSubmit = this.onDeliveryDiscount;

    modalRef.result.then(result => {
      this.onDeliveryDiscount(result, formGp, deliveryType)
    }, fallbackResult => {
      // this.selectedItem = null;
      // this.onCancel.emit(this.form);
    });

  }

  onDeliveryDiscount(form: FormGroup, formGp: string, deliveryType: string) {
    let fullExpiryDateTime = form.value.discount_expiry;
    if (form.value?.discount_expiry_time) {
      let expirydate = moment(fullExpiryDateTime, 'YYYY-MM-DD');
      let expiryTime = moment(form.value.discount_expiry_time, 'HH:mm:ss');
      fullExpiryDateTime = expirydate.format('YYYY-MM-DD') + ' ' + expiryTime.format('HH:mm:ss');
    }

    if (formGp == 'instant_delivery') {
      if (deliveryType == 'mrsool') {
        // this.getInstantDeliveryInfoFormGroup('careem').get('enabled').setValue(0);
        this.getInstantDeliveryInfoFormGroup('mrsool').get('enabled').setValue(1);
        this.getInstantDeliveryInfoFormGroup('mrsool').get('days').setValue(form.value.days);
        this.getInstantDeliveryInfoFormGroup('mrsool').get('mrsool_discount').setValue(form.value.delivery_discount);
        this.getInstantDeliveryInfoFormGroup('mrsool').get('mrsool_min_amount').setValue(form.value.minimum_order_size);
        this.getInstantDeliveryInfoFormGroup('mrsool').get('mrsool_min_discount').setValue(form.value.minimum_discount_size);
        this.getInstantDeliveryInfoFormGroup('mrsool').get('mrsool_expiry_date').setValue(fullExpiryDateTime);
        this.getInstantDeliveryInfoFormGroup('mrsool').get('mrsool_expiry_time').setValue(form.value.discount_expiry_time);
        // this.getInstantDeliveryInfoFormGroup('mrsool').get('mrsool_discount_expiry').setValue(form.value.discount_expiry);
      }

      if (deliveryType == 'careem') {
        // this.getInstantDeliveryInfoFormGroup('mrsool').get('enabled').setValue(0);
        this.getInstantDeliveryInfoFormGroup('careem').get('enabled').setValue(1);
        this.getInstantDeliveryInfoFormGroup('careem').get('days').setValue(form.value.days);
        this.getInstantDeliveryInfoFormGroup('careem').get('careem_discount').setValue(form.value.delivery_discount);
        this.getInstantDeliveryInfoFormGroup('careem').get('careem_min_amount').setValue(form.value.minimum_order_size);
        this.getInstantDeliveryInfoFormGroup('careem').get('careem_min_discount').setValue(form.value.minimum_discount_size);
        this.getInstantDeliveryInfoFormGroup('careem').get('careem_expiry_date').setValue(fullExpiryDateTime);
        this.getInstantDeliveryInfoFormGroup('careem').get('careem_expiry_time').setValue(form.value.discount_expiry_time);
        // this.getInstantDeliveryInfoFormGroup('careem').get('careem_discount_expiry').setValue(form.value.discount_expiry);
      }
    }

    if (formGp == 'same_city_delivery') {
      if (deliveryType == 'mrsool') {
        // this.getSameCityDeliveryInfoFormGroup('careem').get('enabled').setValue(0);
        this.getSameCityDeliveryInfoFormGroup('mrsool').get('enabled').setValue(1);
        this.getSameCityDeliveryInfoFormGroup('mrsool').get('days').setValue(form.value.days);
        this.getSameCityDeliveryInfoFormGroup('mrsool').get('mrsool_discount').setValue(form.value.delivery_discount);
        this.getSameCityDeliveryInfoFormGroup('mrsool').get('mrsool_min_amount').setValue(form.value.minimum_order_size);
        this.getSameCityDeliveryInfoFormGroup('mrsool').get('mrsool_min_discount').setValue(form.value.minimum_discount_size);
        this.getSameCityDeliveryInfoFormGroup('mrsool').get('mrsool_expiry_date').setValue(fullExpiryDateTime);
        this.getSameCityDeliveryInfoFormGroup('mrsool').get('mrsool_expiry_time').setValue(form.value.discount_expiry_time);
        // this.getSameCityDeliveryInfoFormGroup('mrsool').get('mrsool_discount_expiry').setValue(form.value.discount_expiry);
      }
    }

    // this.getInstantDeliveryInfoFormGroup(deliveryType).patchValue(mrsool)
    // this.onSubmit()
  }

  onChangeCountry(item) {
    let countryId = item.id;
    if (countryId == 682) {
      this.outsideSA = false;
      this.storeInformationForm.get('city').setValue(null);
      ['city']?.forEach((field: string) => {
        this.storeInformationForm.get(field).setValue(null);
        this.storeInformationForm.get(field).clearValidators();
        this.storeInformationForm.get(field).updateValueAndValidity();
      });
      ['city_id', 'region_id', 'district_id']?.forEach((field: string) => {
        this.storeInformationForm.get(field).setValidators([Validators.required]);
        this.storeInformationForm.get(field).updateValueAndValidity();
      });
    } else {
      this.outsideSA = true;
      ['city'].forEach((field: string) => {
        this.storeInformationForm.get(field).setValidators([Validators.required]);
        this.storeInformationForm.get(field).updateValueAndValidity();
      });

      ['city_id', 'region_id', 'district_id'].forEach((field: string) => {
        this.storeInformationForm.get(field).setValue(null);
        this.storeInformationForm.get(field).clearValidators();
        this.storeInformationForm.get(field).updateValueAndValidity();
      });
    }
  }

  onChangeRegion(item) {
    let region = item.id;
    if (region) {
      this.loaderService.startLoading();
      this.storeInformationService.getCities(region).subscribe((data: any) => {
        this.cities = data;
        this.loaderService.stopLoading();
      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      })
    }
  }

  onChangeCity(item) {
    let city = item.id;
    this.isLogistiq = false;
    if (city == CITY.JEDDAH) {
      this.isLogistiq = true
    }
    if (city) {
      this.loaderService.startLoading();
      this.storeInformationService.getDistricts(city).subscribe((data: any) => {
        this.districts = data;
        this.loaderService.stopLoading();
      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      })
    }
  }

  onChangeDistrict(item) {

    if (item && item.id && this.storeInformationForm.get('city_id').value == CITY.JEDDAH) {
      this.loaderService.startLoading();
      this.storeInformationService.getDeliveryCostByDistrict(item.id).subscribe((data: any) => {
        this.loaderService.stopLoading();
      }, err => {
        this.loaderService.stopLoading();
        Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
      })
    }
  }
}